import React, { ReactNode } from 'react';

import { Box } from '@adsk/alloy-react-box';
import theme from '@adsk/alloy-react-theme';

const ProductLinksBar = ({ children }: { children: ReactNode }) => (
  <Box
    width="100%"
    height="48px"
    backgroundColor="white"
    borderBottom={`1px solid ${theme.colors.charcoal200}`}
    marginBottom={32}
    padding="0px 48px"
    display="flex"
    flexDirection="row"
    alignItems="center"
  >
    {children}
  </Box>
);

export default ProductLinksBar;
